module.exports = __webpack_public_path__ + "img/logo-main.2053de0b.png";